<template>
	<div class="page mygroup_page">
		<div class="w1240" v-if="typeindex==0">
			<div class="block30"></div>
			<div class="mygroup_typebox">
				<div class="line"></div>
				<div class="text fontsize32">我的社团</div>
			</div>
			<div class="dataListbox">
				<div class="itemobj" :class="getRowClass(index)" v-for="(item,index) in dataList" :key="index"
					@click="handledetail(item)">
					<div class="groupname clamp fontsize16">{{item.title}}</div>
					<div class="groupcon clamp fontsize20">{{item.discription}}</div>
					<div class="grouptime fontsize14">{{$util.replaceTspli(item.createDate)}}</div>
				</div>
			</div>
			<div class="dataListbox" v-if="dataList.length<=0">
				<div class="nolist">你暂未加入学习社团，请联系教师邀请加入！</div>
			</div>
		</div>
		<div class="w1200" v-if="typeindex==1">
			<div class="back_typebox" @click="handletype(0)">
				<img class="icon" src="../assets/static/leftgo.png" />
				<div class="text fontsize16">返回社团</div>
			</div>
			<div class="group_detailbox">
				<div class="leftbox">
					<div class="box1">
						<div class="typebox">
							<div class="line"></div>
							<div class="text fontsize20">{{dataobj.title}}</div>
						</div>
						<div class="textbox">
							<div class="text1 fontsize14">社团描述</div>
							<div class="text2 fontsize16">{{dataobj.discription}}</div>
						</div>
						<div class="textbox">
							<div class="text1 fontsize14">社团分类</div>
							<div class="text2 fontsize16">
								<el-tag :key="tag" v-for="tag in infoTags">
									{{tagFormat(tag)}}
								</el-tag>
							</div>
						</div>
						<div class="textbox">
							<div class="text1 fontsize14">社团组建时间</div>
							<div class="text2 fontsize16">{{$util.replaceTspli(dataobj.createDate)}}</div>
						</div>
					</div>
					<div class="block20"></div>
					<div class="box1">
						<div class="typebox">
							<div class="line"></div>
							<div class="text fontsize20">通知栏</div>
						</div>
						<div class="textbox">
							<!-- <div class="text1 fontsize14"></div> -->
							<div class="text2 fontsize16" style="white-space: pre-wrap;">
								{{dataobj.discription2 || "暂无通知"}}</div>
						</div>
					</div>
					<div class="block20"></div>
					<!-- <div class="box1">
						<div class="typebox">
							<div class="line"></div>
							<div class="text fontsize20">社团成员</div>
						</div>
						<div class="textbox1">
							<div class="text1 fontsize14">名字</div>
							<div class="text2 fontsize14">加入时间</div>
						</div>
						<div class="textbox2" v-for="(item,index) in groupmenber" :key="index" v-if="item.nikename">
							<div class="text1 fontsize14">{{item.hlUser.nikename}}</div>
							<div class="text2 fontsize14">{{$util.replaceTspli(item.createDate)}}</div>
						</div>
					</div> -->
				</div>
				<div class="rightbox">
					<div class="typebox">
						<div class="line"></div>
						<div class="text fontsize20">作业/竞赛</div>
					</div>
					<div class="itemobj fontsize14">
						<div class="text1">标题</div>
						<div class="text2">状态</div>
						<div class="text3">开始时间</div>
						<div class="text4">计分结束时间</div>
						<div class="text5"></div>
					</div>
					<div class="itemobj1 fontsize14" v-for="(item,index) in zuoyeList" :key="index">
						<div class="text1">{{item.title}}</div>
						<div class="text2">
							<span class="c1" v-if="item.typeTag=='ing'">进行中</span>
							<span class="c2" v-if="item.typeTag=='end'">已结束</span>
							<span class="c3" v-if="item.typeTag=='before'">未开始</span>
							<span class="c2" v-if="item.typeTag=='on'">补做中</span>
						</div>
						<div class="text3">{{item.examStartTime}}</div>
						<div class="text4">{{item.scoreEndTime}}</div>
						<div class="text5" @click="handleworkDetail(item.id)">查看详情</div>
					</div>
				</div>
			</div>
			<!-- 学生课程表 -->
			<div style="width: 100%;margin-top: 18px;" v-if="userInfo.userType===0&&dataobj.schedulerUrl">
				<img class="schedulerUrl" style="width: 100%;height: auto;" :src="dataobj.schedulerUrl"/>
			</div>
			<!-- 课时 -->
			<div class="class_stu_box" v-if="userInfo.userType===1">
				<div class="stu_box">
					<div class="itemtop fontsize14">
						<div class="item item1">序号</div>
						<div class="item item2">学生名字</div>
						<div class="item item3">当前阶段</div>
						<div class="item item4">剩余课时</div>
						<div class="item item5">上课状态</div>
						<div class="item item6">信息录入</div>
					</div>
					<div class="itemtop fontsize14 itemobj" v-for="(item,index) in stuClassList" :key="index">
						<div class="item item1">{{index+1}}</div>
						<div class="item item2">{{item.hlUser?item.hlUser.nikename :"匿名"}}</div>
						<div class="item item3">{{item.hlUserCourseHours?item.hlUserCourseHours.hoursStage :"暂无"}}</div>
						<div class="item item4">{{item.hlUserCourseHours?item.hlUserCourseHours.afterRemainingHours :"暂无"}}</div>
						<div class="item item5">
							<div class="text text1" :class="{'text11':item.flowType==0}" @click="handleflowType(index,0)">正常</div>
							<div class="text text3" :class="{'text33':item.flowType==1}" @click="handleflowType(index,1)">免费</div>
							<div class="text text4" :class="{'text44':item.flowType==2}" @click="handleflowType(index,2)">缺课</div>
						</div>
						<div class="item item6">
							<div class="text text1" @click="handlebuke(item)">补课</div>
							<div class="text text2" @click="handleluru(index,item)">录入信息</div>
						</div>
					</div>
				</div>
				<div class="classopen">
					<div class="text1 fontsize16">任课老师：{{userInfo.nikename}}</div>
					<div class="text2 fontsize16" @click="handleopenclass">开始上课</div>
				</div>
			</div>

		</div>
		<div class="block30"></div>
		<el-dialog title="王同学的信息录入" :visible.sync="dialogVisible" width="458px" top="5vh" :close-on-click-modal="false">
			<el-form label-position="top">
				<el-form-item label="学生资质">
					<el-input v-model="formObj.qualification" placeholder="请输入"></el-input>
				</el-form-item>
				<el-form-item label="学生能力阶段">
					<el-input v-model="formObj.abilityStage" placeholder="请输入"></el-input>
				</el-form-item>
				<el-form-item label="竞赛情况">
					<el-input v-model="formObj.competitionInfo" type="textarea" :rows="4" placeholder="请输入"></el-input>
				</el-form-item>
				<el-form-item label="教师评价">
					<el-input v-model="formObj.teacherEvaluation" type="textarea" :rows="4" placeholder="请输入"></el-input>
				</el-form-item>
			</el-form>
			<div style="text-align: center; margin-top: 20px">
				<el-button type="primary" @click="dialogVisible = false">取消</el-button>
				<el-button type="primary" @click="onsubmitluru">确定录入</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import {
		mapState
	} from 'vuex'
	export default {
		data() {
			return {
				typeindex: 0, //0是小 1是详情
				dataList: [], //社团
				typeList: [], //社团类型
				dataobj: {}, //社团对象
				infoTags: [], //社团类型
				groupmenber: [], //社团成员
				zuoyeList: [], //作业
				stuClassList: [], //上课详情
				formObj: {
					abilityStage: "",
					competitionInfo: "",
					qualification: "",
					teacherEvaluation: "",
					userUuid: "",
					index:0
				},
				dialogVisible: false, //信息录入
			};
		},
		mounted: function() {

		},
		activated() {
			if (this.typeindex == 0 && this.dataList.length <= 0) {
				//获取我的社团类型
				this.getmyGrouptype()
			}
		},
		computed: {
			...mapState(['userInfo', 'isLogin', 'sysRole']),
		},
		methods: {
			//开始上课
			handleopenclass(){
				var _this = this
				//老师
				_this.$confirm("点名完成，是否确定上课，扣除上课学生课时。", '提示', {
					confirmButtonText: '确定上课',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var params = {
						groupId: _this.dataobj.id,
						userUuid:_this.userInfo.uuid,
						detailList: []
					}
					var stuClassList = _this.stuClassList
					for(var i=0;i<stuClassList.length;i++){
						params.detailList.push({
							flowType: stuClassList[i].flowType,
							userUuid: stuClassList[i].userUuid
						})
					}
					_this.$http.post('app/hlexam/hlUserGroup/upClass', params).then(function(res) {
						//数据处理
						if (res.code == 200) {
							_this.$message.success("上课成功！")
							_this.stuClassList.forEach((item, index) => {
								item["flowType"] = 0 //上课类型 0正常 1免费 2缺课 3补课
								item["ifclass"] = false //是否补课
							});
						} else {
							_this.$confirm(res.message, '提示', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning'
							}).then(() => {}).catch(() => {});
						}
					})
				}).catch(() => {});
			},
			//上课状态
			handleflowType(index,flowType){
				this.stuClassList[index].flowType = flowType
			},
			//学生录入
			handleluru(index,item) {
				this.dialogVisible = true
				this.formObj = {
					abilityStage: item.hlUser.abilityStage,
					competitionInfo: item.hlUser.competitionInfo,
					qualification: item.hlUser.qualification,
					teacherEvaluation: item.hlUser.teacherEvaluation,
					userUuid: item.userUuid,
					index:index
				}
			},
			//确认录入
			onsubmitluru(){
				var _this = this
				var params = this.formObj
				_this.$http.post('app/hlexam/hlUserGroup/putInfo', params).then(function(res) {
					//数据处理
					if (res.code == 200) {
						_this.$message.success("录入成功！")
						_this.dialogVisible = false
						Object.assign(_this.stuClassList[_this.formObj.index].hlUser,_this.formObj)
					} else {
						_this.$confirm(res.message, '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {}).catch(() => {});
					}
				})
			},
			//补课
			handlebuke(item){
				var _this = this
				//老师
				_this.$confirm("是否确定为"+item.hlUser.nikename+"学生进行补课 ", '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var params = {
						groupId: _this.dataobj.id,
						userUuid:_this.userInfo.uuid,
						detailList: [
						    {
						      flowType: 3,
						      userUuid: item.userUuid
						    }
						]
					}
					_this.$http.post('app/hlexam/hlUserGroup/upClass', params).then(function(res) {
						//数据处理
						if (res.code == 200) {
							_this.$message.success("补课成功！")
						} else {
							_this.$confirm(res.message, '提示', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning'
							}).then(() => {}).catch(() => {});
						}
					})
				}).catch(() => {});
			},
			//获取社团上课详情学生信息
			getmyGroupStuClass(){
				var _this = this
				//老师
				if (this.userInfo.userType&&this.userInfo.userType===1) {
					var params = {
						groupId: this.dataobj.id
					}
					this.$http.post('app/hlexam/hlUserGroup/memberList', params).then(function(res) {
						//数据处理
						if (res.code == 200) {
							res.data.forEach((item, index) => {
								item["flowType"] = 0 //上课类型 0正常 1免费 2缺课 3补课
								item["ifclass"] = false //是否补课
							});
							_this.stuClassList = res.data
						} else {
							_this.$confirm(res.message, '提示', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning'
							}).then(() => {}).catch(() => {});
						}
					})
				}
			},
			getmyGroup() {
				var _this = this
				//需要登录
				if (this.isLogin) {
					var params = {
						currentPage: 1,
						pageSize: 8888,
					}
					params["userUuid"] = this.userInfo.uuid
					this.$http.post('app/hlexam/hlUserGroup/myGroup', params).then(function(res) {
						//数据处理
						if (res.code == 200) {
							_this.dataList = res.data.records
						} else {
							_this.$confirm(res.message, '提示', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning'
							}).then(() => {}).catch(() => {});
						}
					})
				}
			},
			//获取我的社团
			getmyGroup() {
				var _this = this
				//需要登录
				if (this.isLogin) {
					var params = {
						currentPage: 1,
						pageSize: 8888,
					}
					params["userUuid"] = this.userInfo.uuid
					this.$http.post('app/hlexam/hlUserGroup/myGroup', params).then(function(res) {
						//数据处理
						if (res.code == 200) {
							_this.dataList = res.data.records
						} else {
							_this.$confirm(res.message, '提示', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning'
							}).then(() => {}).catch(() => {});
						}
					})
				}
			},
			//获取我的社团类型
			getmyGrouptype() {
				var _this = this
				//需要登录
				if (this.isLogin) {
					var params = {
						currentPage: 1,
						pageSize: 8888,
					}
					params["userUuid"] = this.userInfo.uuid
					this.$http.post('app/hlexam/hlUserGroupType/index', params).then(function(res) {
						//数据处理
						if (res.code == 200) {
							_this.typeList = res.data.records
							//获取我的社团
							_this.getmyGroup()
						} else {
							_this.$confirm(res.message, '提示', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning'
							}).then(() => {}).catch(() => {});
						}
					})
				}
			},
			//获取我的社团作业
			handlezuoyeList() {
				var _this = this
				//需要登录
				var params = {
					currentPage: 1,
					pageSize: 8888,
					testType: 1,
				}
				//params["userUuid"] = this.userInfo.uuid
				params["userGroup"] = this.dataobj.id
				this.$http.post('app/hlexam/hlQuestExam/index', params).then(function(res) {
					//数据处理
					if (res.code == 200) {
						//作业状态
						res.data.records.forEach((item, index) => {
							// console.log(row)
							var examStartTime = _this.$util.getDateTime2(item.examStartTime)
							var examEndTime = _this.$util.getDateTime2(item.examEndTime)
							var scoreEndTime = _this.$util.getDateTime2(item.scoreEndTime || item
								.examEndTime)
							try {
								item["typeTag"] = _this.$util.compareTimes2(examStartTime, examEndTime,
									scoreEndTime)
							} catch (e) {
								item["typeTag"] = ""
							}
						});
						_this.zuoyeList = res.data.records
					} else {
						_this.$confirm(res.message, '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {}).catch(() => {});
					}
				})
			},
			//获取我的社团成员
			hlUserGroupMember() {
				var _this = this
				//需要登录
				var params = {
					currentPage: 1,
					pageSize: 8888,
				}
				params["groupId"] = this.dataobj.id
				this.$http.post('/app/hlexam/hlUserGroupMember/index2', params).then(function(res) {
					//数据处理
					if (res.code == 200) {
						_this.groupmenber = res.data.records
					} else {
						_this.$confirm(res.message, '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {}).catch(() => {});
					}
				})
			},
			//颜色
			getRowClass(index) {
				// 根据需要判断第1第2第3第4列的倍数
				const multipleClasses = {
					'1': 'first-column',
					'2': 'second-column',
					'3': 'third-column',
					'4': 'fourth-column'
				};
				let classNames = '';
				Object.keys(multipleClasses).forEach(multiple => {
					if (index % multiple === 0) {
						classNames += ` ${multipleClasses[multiple]}`;
					}
				});
				return classNames.trim();
			},
			//标签
			tagFormat(tag) {
				const obj = this.typeList.find((ifitem) => { //这里的options就是上面遍历的数据源
					return ifitem.id == tag; //筛选出匹配数据
				});
				if (obj) {
					return obj.title
				} else {
					return tag
				}
			},
			//跳转
			handledetail(item) {
				// this.$router.push({
				// 	path: "/class",
				// 	query:{
				// 		uid:uid
				// 	}
				// });
				this.infoTags = []
				try {
					this.infoTags = JSON.parse(item.infoTags)
				} catch (e) {
					//TODO handle the exception
				}
				this.dataobj = item
				this.handletype(1)
				//获取我的社团作业
				this.handlezuoyeList()
				//获取我的社团成员
				this.hlUserGroupMember()
				//获取社团上课详情学生信息
				this.getmyGroupStuClass()
			},
			//作业赛事详情
			handleworkDetail(uid) {
				this.$router.push({
					path: "/mygroupwork",
					query: {
						uid: uid
					}
				});
			},
			//类型
			handletype(type) {
				this.typeindex = type
			},


		}
	};
</script>
<style lang="scss" scoped></style>